import { Button } from '@massilia/ui'
import { Link } from '@tanstack/react-router'
import { Plane, SearchX } from 'lucide-react'

interface NoResultsCardProps {
  departureLabel?: string
  destinationLabel?: string
}

/**
 * Plus de repli « rechercher sans bagages en soute » : la recherche part en deux
 * exemplaires (avec et sans forçage bagage) et les réunit, donc une liste vide
 * l'est sur les deux axes — proposer d'en retenter un serait un bouton qui ne
 * change rien.
 */
export function NoResultsCard({ departureLabel, destinationLabel }: NoResultsCardProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-gray-200 bg-white px-8 py-12 shadow-sm">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-orange-50">
        <SearchX className="h-10 w-10 text-orange-500" />
      </div>

      <h2 className="mb-2 text-xl font-semibold text-gray-900">Aucun vol disponible</h2>

      <p className="mb-6 max-w-md text-center text-gray-600">
        {departureLabel && destinationLabel ? (
          <>
            Nous n&apos;avons trouvé aucun vol entre{' '}
            <span className="font-medium">{departureLabel}</span> et{' '}
            <span className="font-medium">{destinationLabel}</span> pour les dates et critères
            sélectionnés.
          </>
        ) : (
          <>Nous n&apos;avons trouvé aucun vol correspondant à vos critères de recherche.</>
        )}
      </p>

      <div className="mb-8 rounded-lg bg-gray-50 p-4">
        <p className="mb-3 text-sm font-medium text-gray-700">Suggestions :</p>
        <ul className="space-y-2 text-sm text-gray-600">
          <li className="flex items-start gap-2">
            <Plane className="mt-0.5 h-4 w-4 shrink-0 text-gray-400" />
            <span>Essayez des dates différentes ou plus flexibles</span>
          </li>
          <li className="flex items-start gap-2">
            <Plane className="mt-0.5 h-4 w-4 shrink-0 text-gray-400" />
            <span>Vérifiez l&apos;orthographe des aéroports</span>
          </li>
          <li className="flex items-start gap-2">
            <Plane className="mt-0.5 h-4 w-4 shrink-0 text-gray-400" />
            <span>Élargissez votre recherche à des aéroports proches</span>
          </li>
          <li className="flex items-start gap-2">
            <Plane className="mt-0.5 h-4 w-4 shrink-0 text-gray-400" />
            <span>Modifiez le nombre de passagers ou la classe de voyage</span>
          </li>
        </ul>
      </div>

      <Link to="/recherche">
        <Button className="bg-brand-600 hover:bg-brand-700">
          <Plane className="mr-2 h-4 w-4" />
          Nouvelle recherche
        </Button>
      </Link>
    </div>
  )
}
